'use strict';

// 数组里的值是否都在某区间范围内
const arrayRange = (message, min, max) => {
  return {
    trigger: 'change',
    validator: (rule, vaild, value) => {
      let isRange = value.every(k => {
        if (k) {
          return min <= Number(k) && Number(k) <= max ? true : false;
        } else {
          return false;
        }
      });
      return isRange ? undefined : message;
    }
  };
};

// 异步自定义验证
const asyncCustomValid = (message, fun, trigger = "blur") => {
  return {
    trigger: trigger,
    message: message,
    validator: async (rule, vaild, value) => {
      if (value) {
        let res = await fun(value);
        return res
      } else {
        return undefined;
      }
    }
  };
};

// 字节符长度验证（中文占2个字节符，字母数字占1个字节符）
const byteLength = (message, min, max, trigger = 'blur') => {
  return {
    message: message,
    type: 'string',
    trigger: trigger,
    validator: (rule, vaild, value) => {
      if (value) {
        //字符编码大于255，说明是双字节字符
        let res = value.split('').filter(item => item.charCodeAt(0) > 255);
        //原来的长度+双字节字符的数量
        var num = value.length + res.length;
        return min <= num && num <= max ? undefined : message;
      } else {
        return undefined;
      }
    }
  };
};

// 比较大小，key1要大于key2
const compareSize = (message, key1, key2, trigger = "change") => {
	return {
		trigger,
		validator: vm => {
			let val1 = vm.formData.fields[key1].value;
			let val2 = vm.formData.fields[key2].value;
			if (val1 && val2) {
				return Number(val1) >= Number(val2) ? undefined : message;
			} else {
				return undefined;
			}
		}
	};
};

// 自定义校验
const customValid = (message, fn, trigger = 'change') => {
  return {
    message: message,
    trigger: trigger,
    validator: (rule, vaild, value) => {
      if (typeof fn == 'function') {
        return fn(value) ? undefined : message;
      }
    }
  };
};

// 长度校验
const length = (message, min, max, trigger = 'blur') => {
  return {
    message: message,
    trigger: trigger,
    validator: (rule, vaild, value) => {
      if (value) {
        let length = 0;
        if (typeof value === "number") {
          length = value.toString().length; // 数字不能直接.length
        } else {
          length = value.length;
        }
        return min <= length && length <= max ? undefined : message;
      } else {
        return undefined;
      }
    }
  };
};

var reg = {
  // 邮箱验证
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // 手机验证   规则：以1开头,后面必须是10位数字组成
  mobile: /^1\d{10}$/,
  // 整数或者小数 保留两位有效小数
  number: /^-?[0-9]+\.{0,1}[0-9]{0,2}$/,
  // 正整数验证  
  int: /^[1-9]\d*$/,
  // 整数验证  
  int0: /^[0-9]\d*$/,
  // 英文字母验证
  alpha: /^[a-z]+$/i,
  // 英文加数字
  alphaNumer: /^[a-z0-9]+$/i,
  // 地址验证
  url: /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/,
  // ip验证
  ip: /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/i,
  // 日期格式验证 目前只支持 2018-xx-xx
  date: /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/,
  // 金额验证  目前只支持保留两位小数
  money: /^(-)?(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/,
  // 固定电话验证
  tel: /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/,
  // 密码验证  规则：8-16位(需至少包含1个数字、1个小写字母、1个大写字母和1个特殊字符)
  pwd: /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*((?=[\x21-\x7e]+)[^A-Za-z0-9])).*$/,
  // 身份证
  id: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
};

// 判断金额是否在某一范围内
const moneyRange = (message, min, max) => {
  return {
    trigger: 'change',
    message,
    validator: (vm, vaild, value) => {
      return reg.money.test(value) && min <= Number(value) && Number(value) <= max ? undefined : message
    }
  };
};

// 判断数字的小数位不能大于某值
const numberPoint = (message, num) => {
  return {
    trigger: 'change',
    message,
    validator: (vm, vaild, value) => {
      let point = value.toString().split(".")[1] && value.toString().split(".")[1].length || 0;
      return point <= num ? undefined : message
    }
  };
};

// 判断某个数字是否在某区间范围内
const numberRange = (message, min, max, trigger = 'blur') => {
  return {
    message: message,
    trigger: trigger,
    validator: (rule, vaild, value) => {
      if (value) {
        return min <= Number(value) && Number(value) <= max ? undefined : message;
      } else {
        return undefined;
      }
    }
  };
};

// 判断范围区间差值要大于某值
const rangeSize = (message, num, trigger = "change") => {
  return {
    trigger,
    message,
    validator: (vm, vaild, value) => {
      if (value && value.length == 2) {
        let val = value[1] - value[0];
        return Math.abs(val) >= num ? undefined : message;
      }
      return message;
    }
  };
};

const regValid = (message, type, trigger = "change") => {
  return {
    trigger,
    message,
    validator: (vm, vaild, value) => {
      return reg[type].test(value) ? undefined : message
    }
  };
};

const required = (message, trigger = 'change') => {
	return {
		required: true,
		message: message,
		trigger: trigger,
		validator: (rule, vaild, value) => {
			if (typeof value == 'number') {
				return value || value === 0 ? undefined : message;
			} else {
				return value && value.length ? undefined : message;
			}
		}
	};
};

const requiredCustom = (message, fn, trigger = 'change') => {
  return {
    required: true,
    message: message,
    trigger: trigger,
    validator: (rule, vaild, value) => {
      if (typeof fn == 'function') {
        return fn(value) ? undefined : message;
      }
    }
  };
};

// 多个表单的value不能同时为0
const valuesNoZero = (message, keyData = [key1, key2]) => {
  return {
    trigger: 'change',
    validator: vm => {
      let newData = [];
      newData = keyData.filter(item => {
        return vm.formData.fields[item].visable()
      });
      let isZero = newData.every(k => vm.formData.fields[k].value.toString() === "0");
      return isZero ? message : undefined;
    }
  };
};

var index = {
arrayRange,
asyncCustomValid,
byteLength,
compareSize,
customValid,
length,
moneyRange,
numberPoint,
numberRange,
rangeSize,
reg,
regValid,
required,
requiredCustom,
valuesNoZero,
};

module.exports = index;
